/**
 * Units Catalog Object
 */
export const ScaleSymbol = {
  None: '',
  Kilo: 'k',
  Mega: 'M',
  Giga: 'G',
};

export const ScaleSymbolArray = [
  ScaleSymbol.None,
  ScaleSymbol.Kilo,
  ScaleSymbol.Mega,
  ScaleSymbol.Giga,
];

export const UnitMeasurementSymbol = {
  Watthour: 'Wh',
  Watt: 'W',
  ApparentPower: 'VA',
};

/**
 * Catalogue of scales values
 */
export const ScaleValues = {
  Giga: 1000000000,
  Mega: 1000000,
  Kilo: 1000,
};
